// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e079b71f","513":"504819f3","703":"fa31685c"}[chunkId] + ".chunk.js";
};